var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-manager"},[_c('iframe',{staticClass:"iframe-placeholder",attrs:{"src":_vm.dashboard,"frameborder":"0","width":"100%","height":"100%","allowtransparency":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }